import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import backend from "i18next-http-backend";
// import backend from "i18next-locize-backend";
import { AppConfig } from "../config";

const { locales } = AppConfig;

i18n
  .use(backend)
  .use(detector)
  .use(initReactI18next)
  .init(
    {
      backend: {
        loadPath: AppConfig.publicUrl + "/locales/{{lng}}/{{ns}}.json",
        // projectId: AppConfig.locize.projectId,
        // apiKey: AppConfig.locize.apiKey,
        // referenceLng: locales[0].key,
      },
      fallbackLng: locales[0].key,
      supportedLngs: locales.reduce<string[]>((acc, { key }) => {
        const arr = key.split("-");
        if (arr.length === 2) return [...acc, key, arr[0]];
        return [...acc, key];
      }, []),

      ns: ["base"],
      defaultNS: "base",

      react: { wait: true },

      debug: AppConfig.isDevelopment,
    },
    (err) => {
      if (err) {
        return console.log("Error while loading translation file: ", err);
      }
    }
  );

export default i18n;
